/*
 * @Author: Json Chen
 * @Date: 2021-06-18 09:03:31
 * @LastEditTime: 2021-06-18 18:42:06
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/LinkLibrary/type.ts
 */

export enum LinkType {
  URL = 'URL',
  MiniProgram = 'MiniProgram',
}

export interface LinkCommon {
  type: LinkType;
  title: string;
  language: string;
}

export interface LinkUrl extends LinkCommon {
  url: string;
  // 关联小程序
  mini: LinkMini;
}
export interface LinkMini extends LinkCommon {
  appid: string;
  path: string;
  extra: string;
}

export interface LinkItem {
  item: {
    url: string;
    title: string;
  };
  type: string;
  location: string;
}
